import * as api from "services/api";
import { getErrors } from "helpers/error";

export const GET_BENEFIT = "[BENEFIT] GET_BENEFIT";
export const GET_BENEFIT_SUCCESS = "[BENEFIT] GET_BENEFIT_SUCCESS";
export const GET_BENEFIT_FAILED = "[BENEFIT] GET_BENEFIT_FAILED";

export const SET_VALUE = "[BENEFIT] SET_VALUE";
export const CLEAR_VALUES = "[BENEFIT] CLEAR_VALUES";

export function setValue(payload) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getBenefitsByUser(
	skip,
	take,
	filter,
	sort,
	desc,
	toExport,
	callback
) {
	return async (dispatch, getState) => {
		dispatch({ type: GET_BENEFIT });

		try {
			const { login } = getState();

			var response = await api.sendGet(
				`/companyBenefit/by-user?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${filter ||
					"&filters=null"}`,
				{
					Authorization: "Bearer " + login.token
				}
			);

			let result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_BENEFIT_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / take),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_BENEFIT_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_BENEFIT_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
